import { StaticImage } from "gatsby-plugin-image"
import { useCallback } from "react"

import SignupContainer from "./signup-container"
import SignupTop from "./signup-top"

const SignupV2 = () => {
  const image = useCallback(
    ({ alt, className }) => (
      <StaticImage
        src="./images/signup-v2.webp"
        alt={alt}
        className={className}
      />
    ),
    []
  )

  return (
    <SignupContainer buttonLabel="Speichern & Rabatt sichern">
      <SignupTop
        heading={
          <>
            Sichere Dir bis -40 % auf <br />
            Deine erste Bestellung
          </>
        }
        subline="Speichere hier Deinen Rabatt & erhalte Deine Skincare zum Vorteilspreis!"
        image={image}
      />
    </SignupContainer>
  )
}

export default SignupV2
